module.exports = __webpack_public_path__ + "media/country_flags/ng-b0c8c139.png";